export class Stammdatum {
  value?: number | string;
  caption?: string;

  constructor(value: string | number, caption: string) {
    this.value = value;
    this.caption = caption;
  }
}
